import { imageSrc } from "../../lib/api";
import { curated } from "../../lib/curate";

export function DomMontage({ paintings: all }) {
  const paintings = curated(all);
  const rows = [paintings.filter((_, i) => i % 2 === 0), paintings.filter((_, i) => i % 2 === 1)].filter((r) => r.length);
  return (
    <div data-testid="dom-montage" className="absolute inset-0 overflow-hidden bg-gradient-to-b from-[#F3E8FF] via-[#FDF2F8] to-[#E0F2FE]">
      {rows.map((r, ri) => (
        <div
          key={ri}
          className="absolute left-0 flex w-max gap-10 opacity-70"
          style={{ top: ri ? "50%" : "15%", animation: `montage-drift ${48 + ri * 14}s linear infinite`, animationDirection: ri ? "reverse" : "normal" }}
        >
          {[...r, ...r, ...r, ...r].map((p, i) => (
            <img key={i} src={imageSrc(p.image_url)} alt="" className="h-[26vh] w-auto border-[6px] border-white shadow-[0_20px_40px_-20px_rgba(91,58,133,0.45)]" />
          ))}
        </div>
      ))}
    </div>
  );
}
